import type { HTMLAttributes, ReactNode } from 'react';

export type StatusNoticeVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export interface StatusNoticeProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  variant?: StatusNoticeVariant;
}

export function StatusNotice({ children, variant = 'info', className = '', ...props }: StatusNoticeProps) {
  return (
    <div
      data-ui="status-notice"
      data-variant={variant}
      className={`status-notice rounded-xl border p-3 text-sm font-medium ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export default StatusNotice;
